import { render } from "./ClaimList.vue?vue&type=template&id=d2de4c04"
import script from "./ClaimList.vue?vue&type=script&lang=js"
export * from "./ClaimList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__